import React from 'react'

const ActivityTimelineContext = React.createContext({})
export default ActivityTimelineContext
